import { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Box
} from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { STRINGS } from 'src/commons';

const EndingMemberships = ({ data }) => {
  const [page, setPage] = useState(0);
  const headers = ['Title', 'Body'];
  const limit = 20;

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCell key={index}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.slice(0, limit)?.length ? (
                data.slice(0, limit).map((dataItem, index) => (
                  <TableRow
                    hover
                    key={index}
                    // onClick={() => onClickRow(dataItem)}
                  >
                    <TableCell>{dataItem.notification_title}</TableCell>
                    <TableCell>{dataItem.notification_body}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow hover>
                  <TableCell
                    colSpan={headers.length}
                    style={{ textAlign: 'center' }}
                  >
                    {STRINGS.NO_NOTIFICATIONS_FOUND}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      {data?.length ? (
        <TablePagination
          component="div"
          count={data?.length}
          onPageChange={handlePageChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[]}
        />
      ) : null}
    </>
  );
};

export default EndingMemberships;
